export const INTERNAL_USER_ROLES = {
  ADMIN: 'ADMIN',
  SUPPORT: 'SUPPORT',
  MARKETING: 'MARKETING',
  SUPER_ADMIN: 'SUPER_ADMIN',
} as const;

export const USER_ROLES = {
  ...INTERNAL_USER_ROLES,
  HOMEOWNER: 'HOMEOWNER',
  IMPERSONATE_ONLY: 'IMPERSONATE_ONLY',
} as const;

export type RolesKeyInternal = keyof typeof INTERNAL_USER_ROLES;
export type RolesKey = keyof typeof USER_ROLES;

export const languageCode = {
  en: 'ENGLISH',
  es: 'SPANISH',
} as const;

export type LanguageCodeKey = keyof typeof languageCode;
export type PrimaryLanguage = (typeof languageCode)[LanguageCodeKey];

export enum MilestoneType {
  CONTRACT_SIGNED = 'CONTRACT_SIGNED',
  PROJECT_QUALIFICATION_COMPLETED = 'PROJECT_QUALIFICATION_COMPLETED',
  INSTALLATION_COMPLETED = 'INSTALLATION_COMPLETED',
  IN_SERVICE = 'IN_SERVICE',
}

export enum WelcomeChecklistStatusType {
  REQUIRED = 'REQUIRED',
  PASSED = 'PASSED',
  FAILED = 'FAILED',
  NOT_REQUIRED = 'NOT_REQUIRED',
}

export enum AnswerNetVideoTPVStatusType {
  CANCELED = 'canceled',
  PENDING = 'pending',
  VERIFIED = 'verified',
  FAILED = 'failed',
}

export enum WelcomeChecklistResult {
  PASS = 'PASS',
  FAIL = 'FAIL',
}

export enum OnboardingStep {
  INTRODUCTION,
  PRE_INSTALLATION,
  REVIEW_AGREEMENT,
  TPV,
  AUTOPAY,
  CONFIRM_ADDRESS,
  SYSTEM_INSTALLATION,
  SYSTEM_ACTIVATION,
}

export const EDIT_ADDRESS_PARAM = 'editing-address';

export const ONBOARDING_STEP_PARAM = 'onboarding-step';

export interface WelcomeChecklistType {
  id: string;
  user?: string;
  agreement: string;
  checklist: WelcomeChecklistItemType[];
  date_completed: string | null;
  result: WelcomeChecklistResult | null;
}

export interface WelcomeChecklistItemType {
  page: number;
  question_en: string;
  question_es: string;
  answer?: string;
}

export interface SentEmailType {
  id: string;
  email_template: string;
  template_description: string;
  date_sent: string;
  user_email: string;
}

export interface SentNotificationType {
  id: string;
  user_device: string;
  agreement: string;
  name: string;
  category: string;
  title: string;
  body: string;
  date_sent: string;
}

export type ChartDataType = {
  x: number;
  y: number;
  unit: string;
  value: number;
  time: Date;
};

export type AxisType = {
  domain?: [number, number];
  tickValues?: unknown[];
  tickFormat?: (tick: any, index: number, ticks: any) => string | number;
  style?: any;
};

export type Tuple<T> = [T, T];

export declare type PaddingType = number | Tuple<number>;

export enum TabType {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
}

export enum PowerFlowScenario {
  /*
  SOLAR_ONLY: Solar only system when solar can meet all demands but there is no extra to export (highly unlikely)
  */
  SOLAR_ONLY,
  /*
  SOLAR_GRID_SOURCE: In the morning when solar alone cant meet demand
  */
  SOLAR_GRID_SOURCE,
  /*
  SOLAR_BATTERY_SOURCE: Late afternoon when solar can't meet usage needs (Powershift)
  */
  SOLAR_BATTERY_SOURCE,
  /*
  ALL_SOURCES: Huge load in the evening
  */
  ALL_SOURCES,
  /*
  Way to much overproduction (I think this is unlikely to happen often)
  */
  GRID_EXPORT_BATTERY_CHARGING,
  /*
  Midday mostdays on battery systems
  */
  CHARGE_BATTERY_FROM_SOLAR,
  /*
  Surplus solar after battery Is charges or in solar only systems
  */
  SOLAR_EXPORT_TO_GRID,
  /*
  Pre-VPP event or to prepare for inclimate weather.
  */
  SOLAR_GRID_CHARGE_BATTERY,
  /*
  Midday VPP event
  */
  SEND_EVERYTHING_TO_GRID,
  /*
  Night after battery depleated
  */
  GRID_SOURCE_ONLY,
  /*
  Power outage backup mode
  */
  BATTERY_SOURCE_ONLY,
  /*
  Evening powershift cycle
  */
  BATTERY_GRID_SOURCE,
  /*
  Night Evening, Pre VPP event or to help with TOU rates
  */
  CHARGE_BATTERY_FROM_GRID,
  /*
  Battery exports to grid
  */
  BATTERY_EXPORTS_TO_GRID,
}

export enum Flow {
  POSITIVE,
  NEGATIVE,
}
